import React from 'react';
import _ from 'lodash';
import { getPage } from '../../api/contentful';
import { fetchProducts } from '../../api/storefront';
import { fetchReviewsByProductId } from '../../api/yotpo';
import GlowforgeProductsPage from '../../components/products/glowforge-products-page';
import { getSectionById } from '../../util/contentful-data';

const GlowforgeProductsPageContainer = (props) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <GlowforgeProductsPage {...props} />
);

const getYotpoProductIdByModel = (page, model) => {
  const productsListSection = getSectionById(page, 'glowforge-products-list', {});
  const listItems = _.get(productsListSection, 'fields.listItems', []);
  const modelSection = _.find(listItems, { fields: { id: `glowforge-${model}-section` } }, {});
  const nestedSections = _.get(modelSection, 'fields.sections', []);
  // eslint-disable-next-line max-len
  const yotpoProductIdSection = _.find(nestedSections, { fields: { id: `glowforge-${model}-yotpo-product-id` } }, {});
  const yotpoProductId = _.get(yotpoProductIdSection, 'fields.text', '');
  return yotpoProductId;
};

GlowforgeProductsPageContainer.getInitialProps = async () => {
  // Start by fetching the Contentful page. We need to do this first so we can
  // get product IDs to pass to the Yotpo API
  const page = await getPage('glowforge-products-page');

  const proYotpoProductId = getYotpoProductIdByModel(page, 'pro');
  const plusYotpoProductId = getYotpoProductIdByModel(page, 'plus');
  const basicYotpoProductId = getYotpoProductIdByModel(page, 'basic');

  const [
    products,
    proReviews,
    plusReviews,
    basicReviews,
  ] = await Promise.all([
    fetchProducts(),
    proYotpoProductId ? fetchReviewsByProductId(proYotpoProductId) : null,
    plusYotpoProductId ? fetchReviewsByProductId(plusYotpoProductId) : null,
    basicYotpoProductId ? fetchReviewsByProductId(basicYotpoProductId) : null,
  ]);

  return {
    page,
    products,
    proReviews,
    plusReviews,
    basicReviews,
  };
};

GlowforgeProductsPageContainer.propTypes = GlowforgeProductsPage.propTypes;
GlowforgeProductsPageContainer.defaultProps = GlowforgeProductsPage.defaultProps;

export default GlowforgeProductsPageContainer;
